<template>
  <div>
    <vs-popup
      class="holamundo"
      icon-close="X"
      :title="this.title"
      :active.sync="active"
    >      
      <div class="content">
        <section class="section--sidebar-user">
          <section
            class="section--content-sidebar section--content-sidebar-full-height"
          >
            <form
              method="POST"
              :action="this.action"
              accept-charset="UTF-8"
              enctype="multipart/form-data"
              class="workflow-tabs"
            >
              <input type="hidden" name="_token" :value="csrf" />
              <input
                v-if="this.editing"
                type="hidden"
                name="_method"
                value="PUT"
              />
              <div class="tab-content">
                <div class="row">
                  <div class="col-12">
                    <p class="tab-description mt-3 mb-2">Settings Skills</p>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-12 col-md-4">
                    <div class="form-group">
                      <label>{{__("forms.Question.title")}}</label>
                      <input
                        type="text"
                        class="form-control rounded"
                        name="questionBase[name]"
                        :value="name"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="form-group">
                      <label>{{__("forms.Question.description")}}</label>
                      <input
                        type="text"
                        class="form-control rounded"
                        name="questionBase[description]"
                        :value="description"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="form-group">
                      <label>{{__("forms.Question.sorting")}}</label>
                      <input
                        type="number"
                        class="form-control rounded"
                        name="questionBase[sorting]"
                        :value="sorting"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-md-4"></div>
                  <div class="col-12 col-md-4"></div>
                </div>

                <div class="row mb-3">
                  <div
                    class="col-12 col-md-4"
                    v-for="level in all_skill_levels"
                    :key="level.id"
                  >
                    <div class="custom-control custom-switch">
                      <input
                        :name="
                          'questionSettings[set_skill_levels][' + level.id + ']'
                        "
                        type="checkbox"
                        class="custom-control-input"
                        :id="
                          'questionSettings[set_skill_levels][' + level.id + ']'
                        "
                        :value="level.id"
                        v-model="set_skill_levels"
                      />
                      <label
                        class="custom-control-label"
                        :for="
                          'questionSettings[set_skill_levels][' + level.id + ']'
                        "
                      >
                        {{ level.title }}</label
                      >
                    </div>
                  </div>
                </div>

                <div class="row mb 3">
                  <div class="col-12 col-md-4">
                    <div class="custom-control custom-switch">
                      <input
                        name="questionSettings[show_affinity]"
                        type="checkbox"
                        class="custom-control-input"
                        id="questionSettings[show_affinity]"
                        value="1"
                        v-model="showAffinity"
                      />
                      <label
                        class="custom-control-label"
                        for="questionSettings[show_affinity]"
                      >
                        {{ __("forms.EvaluationChart.questions.questions_setting.question7.show_affinity_position") }}
                      </label>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="custom-control custom-switch">
                      <input
                        name="questionSettings[show_level_not_evaluable]"
                        type="checkbox"
                        class="custom-control-input"
                        id="questionSettings[show_level_not_evaluable]"
                        value="1"
                        v-model="showLevelNotEvaluable"
                      />
                      <label
                        class="custom-control-label"
                        for="questionSettings[show_level_not_evaluable]"
                      >
                      {{ __("forms.EvaluationChart.questions.questions_setting.question7.show_not_evaluable_level") }}
                      </label>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="custom-control custom-switch">
                      <input
                        name="questionSettings[hide_required_level]"
                        type="checkbox"
                        class="custom-control-input"
                        id="questionSettings[hide_required_level]"
                        value="1"
                        v-model="hideRequiredLevel"
                      />
                      <label
                        class="custom-control-label"
                        for="questionSettings[hide_required_level]"
                      >
                      {{ __("forms.EvaluationChart.questions.questions_setting.question7.hide_required_level_column") }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row mt-3 mb-3">
                  <div class="col-12">
                    <div class="alert alert-warning">
                      <i class="fas fa-exclamation-triangle"></i>
                      {{ __("forms.EvaluationChart.questions.questions_setting.question7.avg_limit_label") }}
                    </div>
                  </div>
                  <div class="col-6 col-md-6">
                    <label>
                      {{ __("forms.EvaluationChart.questions.questions_setting.question7.set_min_value_avg_global_rating") }}
                    </label>
                    <input type="number" name="questionSettings[min_value_global_rating]" class="form-control" :value="min_value_global_rating">
                  </div>

                  <div class="col-6 col-md-6">
                    <label>
                      {{ __("forms.EvaluationChart.questions.questions_setting.question7.set_max_value_avg_global_rating") }}
                    </label>
                    <input type="number" class="form-control" name="questionSettings[max_value_global_rating]" :value="max_value_global_rating">
                  </div>
              
                </div>

                <div class="row mb-3">
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label>
                        {{ __("forms.EvaluationChart.questions.questions_setting.question7.source_evaluation_skills") }}
                      </label>
                      <select
                        class="form-control rounded"
                        name="questionSettings[src]"
                        :value="src"
                      >
                        <option value="activities_people">
                          {{ __("forms.EvaluationChart.questions.questions_setting.question7.grading_activities_people") }}
                        </option>
                        <option value="skills_roles">
                          {{ __("forms.EvaluationChart.questions.questions_setting.question7.grading_skill_roles") }}
                        </option>
                        <option value="people_skills">
                          {{ __("forms.EvaluationChart.questions.questions_setting.question7.grading_skill_people") }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="col-12">
                    <p class="tab-description mt-3 mb-2">
                      {{ __("forms.EvaluationChart.questions.questions_setting.question7.add_new_delta") }}
                    </p>
                  </div>
                </div>
                <div class="row align-items-center p-2 mb-2">
                  <div class="col-3">
                    <input
                      class="form-control rounded"
                      type="number"
                      v-model="newDeltaNum"
                    />
                  </div>
                  <div class="col-1">
                    <input
                      class="form-control rounded"
                      type="color"
                      v-model="newDeltaColor"
                    />
                  </div>
                  <div class="col-8 text-right">
                    <button type="button" v-on:click="addDelta1" class="btn">
                      {{ __("misc.add") }}
                    </button>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-3">
                        <h6>Delta</h6>
                      </div>
                      <div class="col-3">
                        <h6>
                          {{ __("forms.EvaluationChart.questions.questions_setting.question7.color") }}
                        </h6>
                      </div>
                      <div class="col-3"></div>
                    </div>
                    <div
                      class="row align-items-center p-2 mb-2"
                      v-for="(color, key) in limit"
                      :key="key"
                    >
                      <div class="col-3">
                        <h6>{{ key }}</h6>
                      </div>
                      <div class="col-1">
                        <input
                          class="form-control rounded"
                          :name="'questionSettings[limit][' + key + ']'"
                          type="color"
                          :value="color"
                        />
                      </div>
                      <div class="col-8">
                        <h6 v-if="limitDefault.includes(key)"></h6>
                        <button
                          v-else
                          type="button"
                          class="btn btn--only-icon-rounded btn--danger"
                          @click="rmLimit(key)"
                        >
                          <i class="fas fa-times"></i>
                        </button>
                      </div>
                    </div>
                    <div class="row align-items-center p-2 mb-2">
                      <div class="col-3">
                        <h6>
                          {{ __("forms.EvaluationChart.questions.questions_setting.question7.non_evaluable") }}
                        </h6>
                      </div>
                      <div class="col-1">
                        <input
                          class="form-control rounded"
                          name="questionSettings[unset]"
                          type="color"
                          :value="unset"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <hr />
                  </div>
                  <div class="col-12 mt-3 text-right" v-if="can_write">
                    <button class="btn btn-next" type="submit">
                      {{ __("misc.save") }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </section>
        </section>
      </div>
    </vs-popup>
  </div>
</template>    
<script>
export default {
  props: {
    can_write: {
      type: Boolean,
      required: true,
      default: true
    },
  },
  data() {
    return {
      src: "skills_roles",
      type: "title", // color
      limit: [],
      showLevelNotEvaluable: false,
      showAffinity: false,
      hideRequiredLevel: false,
      limitDefault: ["0", "-10", "10"],
      min_value_global_rating: 0,
      max_value_global_rating: 0,
      set_skill_levels: [],
      all_skill_levels: [],

      unset: "#A8A8A8",
      newDeltaNum: 0,
      newDeltaColor: "#FF00FF",
      //default
      title: "Skills / Activities Levels",
      active: false,
      action: "",
      name: "",
      description: "",
      sorting: -1,
      editing: true,            
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    };
  },
  methods: {
    rmLimit(index) {
      Vue.delete(this.limit, index);
    },
    addDelta1() {
      let cond1 = this.newDeltaNum === "";
      let cond2 = this.limit.hasOwnProperty(this.newDeltaNum);

      if (cond1 || cond2) {
        alert("Delta is empty or is already set");
        return false;
      }
      Vue.set(this.limit, this.newDeltaNum, this.newDeltaColor); //Best method to do it
    },
    toggle(action, item_id, editing, attributes) {
      this.active = true;
      this.action = action;
      this.editing = editing;
      this.lang = attributes.lang;
      let dataRoute = decodeURI(attributes.dataRoute);
      if (dataRoute !== undefined) {
        if (dataRoute.indexOf("[id]") > 0) {
          dataRoute = dataRoute.replace("[id]", item_id);
        }
        axios.get(dataRoute).then((response) => {
          this.name = response.data.base.name;
          this.description = response.data.base.description;
          this.sorting = response.data.base.sorting;
          this.src = response.data.settings.src;
          this.type = response.data.settings.type;
          this.limit = response.data.settings.limit;
          this.unset = response.data.settings.unset;
          this.min_value_global_rating = response.data.settings.min_value_global_rating;
          this.max_value_global_rating = response.data.settings.max_value_global_rating;
          this.set_skill_levels = response.data.settings.set_skill_levels;
          this.all_skill_levels = response.data.settings.all_skill_levels;
          this.showLevelNotEvaluable = response.data.settings.show_level_not_evaluable;
          this.showAffinity = response.data.settings.show_affinity;
          this.hideRequiredLevel = response.data.settings.hide_required_level;          
          this.can_write = app.__vue__.questionPermission(
            this.can_write,
            response.data.base.enable
          );
        });
      }
    },
  },
};
</script>
    
    